import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-form-submit-button',
  templateUrl: './form-submit-button.component.html',
  styleUrls: ['./form-submit-button.component.scss'],
})
export class FormSubmitButtonComponent implements OnInit {

  @Input() labelText: string;
  @Output() onClickHandle = new EventEmitter();
  @Input() showIcon : Boolean = true

  /**
   * True for the length of the press animation. :active only lasts while the
   * pointer is held, which cuts the animation off mid-flight, so the press is
   * latched here instead. Purely presentational — screens that do not style
   * `.is-pressed` are unaffected.
   */
  pressed = false;

  constructor() { }

  ngOnInit() {
  }

  handleClick() {
    this.pressed = true;
    setTimeout(() => { this.pressed = false; }, 600);
    this.onClickHandle.emit();
  }

}
